import { ChakraProvider } from "@chakra-ui/react";
import "./App.css";
import Provider from "./context/Provider";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useState } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import theme from "./theme";
import PresenceTracker from "./components/presence/PresenceTracker";
import ChatSocketProvider from "./chat/ChatSocketProvider";

function MyApp() {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <ChakraProvider theme={theme}>
      <Provider>
        <QueryClientProvider client={queryClient}>
          <PresenceTracker />
          <ChatSocketProvider>
            <RouterProvider router={router} />
          </ChatSocketProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </ChakraProvider >
  );
}

export default MyApp;
